<section class="custom-section">
  <customer-title-content [title]="labels.chooseLogger">
  </customer-title-content>
  <customer-choice-with-img
    [labels]="{
      connext: labels.connext,
      azzurroHub: labels.azzurroHub,
      others: labels.others,
    }"
    [loggers]="loggers"
    (interaction)="monitoringPreference.updateValueAndValidity(); changeLogger.emit()">
  </customer-choice-with-img>
</section>

<section
  *ngIf="isConnextLoggerSelected"
  class="custom-section">
  <customer-title-content [title]="labels.connextSerial">
  </customer-title-content>
  <customer-simple-input
    *ngIf="{ robustnessOnFormInput: robustnessOnFormInput$ | async }"
    class="mb-6"
    [placeholder]="labels.connextPlaceholder"
    [input]="monitoringForm.controls.connextSerial"
    [errorMessage]="connextErrorMessage | translate"
    (clear)="clearInput()">
  </customer-simple-input>

  <section
    *ngIf="connextSerial?.errors?.unique; else checkHasOwner"
    class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
    <customer-icon-text [text]="labels.alreadyInserted">
    </customer-icon-text>
    <customer-title-content [content]="labels.alreadyInsertedDescription">
    </customer-title-content>
    <customer-simple-button
      *ngIf="connextSerial?.errors?.value as value"
      [label]="labels.searchSystem"
      [action]="searchSystem($any(value))">
    </customer-simple-button>
  </section>

  <ng-template #checkHasOwner>
    <ng-container *ngIf="(connextSerial?.errors?.hasOwnerAndItsNotMe || connextSerial?.errors?.iamAlreadyAdmin); else checkFwUpdating">
      <section class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
        <customer-icon-text [text]="labels.plantAlreadyCreated">
        </customer-icon-text>
        <ng-container *ngIf="enableImportSystem">
          <customer-title-content [content]="labels.plantAlreadyCreatedDescription">
          </customer-title-content>
          <customer-title-content [title]="labels.systemName">
          </customer-title-content>
          <customer-simple-input
            [placeholder]="labels.systemNamePlaceholder"
            [input]="importSystemName">
          </customer-simple-input>
          <!-- Import -->
          <ng-container *ngIf="connextSerial?.errors?.uid as uid">
            <customer-simple-button
              [label]="labels.import"
              [disabled]="!importSystemName.value"
              [action]="importSystemName.value && createPlant(importSystemName.value, uid)">
            </customer-simple-button>
          </ng-container>
        </ng-container>
      </section>
    </ng-container>
  </ng-template>

  <!-- Fota in progress -->
  <ng-template #checkFwUpdating>
    <section
      *ngIf="connextSerial?.errors?.fwUpdating; else checkIfOnline"
      class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
      <customer-icon-text [text]="labels.requiredOperation">
      </customer-icon-text>
      <customer-title-content [content]="labels.firmwareOperationDescription">
      </customer-title-content>
      <mat-icon
        class="s-40 min-s-40 mx-auto"
        svgIcon="customer_connext_update">
      </mat-icon>
      <customer-simple-button
        [label]="labels.checkAgain"
        [action]="updateValueAndValidity">
      </customer-simple-button>
    </section>
  </ng-template>

  <!-- Device Not Online -->
  <ng-template #checkIfOnline>
    <section
      *ngIf="connextSerial?.errors?.deviceNotOnline; else checkIfFwVersionNotValid"
      class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
      <customer-icon-text [text]="labels.offlineDevice">
      </customer-icon-text>
      <customer-title-content [content]="labels.offlineDeviceDescription">
      </customer-title-content>
      <customer-simple-button
        [label]="labels.checkAgain"
        [action]="updateValueAndValidity">
      </customer-simple-button>
    </section>
  </ng-template>

  <!-- Device with fw version not valid -->
  <ng-template #checkIfFwVersionNotValid>
    <section
      *ngIf="connextSerial?.errors?.fwVersionNotValid"
      class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
      <customer-icon-text [text]="labels.requiredOperation">
      </customer-icon-text>
      <customer-title-content [content]="labels.firmwareNotValidDescription">
      </customer-title-content>

      <!-- If i'm the owner/admin -->
      <ng-container *ngIf="connextSerial?.errors?.fwVersionNotValid && !connextSerial?.errors?.hasOwnerAndItsNotMe">
        <ng-container *ngIf="connextSerial?.errors?.uid as uid">
          <customer-simple-button
            [label]="labels.upgradeFirmware"
            [action]="createFirebaseBlockService.updateConnextFw(
              uid,
              updateValueAndValidity,
              {
                loadingMessage: labels.requestingFirmwareUpdate,
                fwUpdateTitle: labels.fwUpdateTitle,
                fwUpdateContent: labels.fwUpdateContent,
              }
            )">
          </customer-simple-button>
        </ng-container>
      </ng-container>
    </section>
  </ng-template>
</section>

<section
  *ngIf="isAzzurroHubLoggerSelected && hasAzzurroHubSerial"
  class="custom-section">
  <customer-title-content [title]="labels.azzurroHubSerial">
  </customer-title-content>
  <customer-simple-input
    *ngIf="{ robustnessOnAzzurroHubFormInput: robustnessOnAzzurroHubFormInput$ | async }"
    class="mb-6"
    [placeholder]="labels.azzurroHubPlaceholder"
    [input]="azzurroHubSerial"
    [errorMessage]="azzurroHubErrorMessage | translate"
    (clear)="clearInput()">
  </customer-simple-input>

  <section
    *ngIf="azzurroHubSerial?.errors?.unique; else checkAzzurroHubHasOwner"
    class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
    <customer-icon-text [text]="labels.alreadyInserted">
    </customer-icon-text>
    <customer-title-content [content]="labels.alreadyInsertedDescription">
    </customer-title-content>
    <customer-simple-button
      *ngIf="azzurroHubSerial?.errors?.value as value"
      [label]="labels.searchSystem"
      [action]="searchSystem($any(value))">
    </customer-simple-button>
  </section>

  <ng-template #checkAzzurroHubHasOwner>
    <ng-container *ngIf="azzurroHubSerial?.errors?.iamAlreadyAdmin; else checkAzzurroHubBusy">
      <section class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
        <customer-icon-text [text]="labels.plantAlreadyCreated">
        </customer-icon-text>
        <ng-container *ngIf="enableImportSystem">
          <customer-title-content [content]="labels.plantAlreadyCreatedDescription">
          </customer-title-content>
          <customer-title-content [title]="labels.systemName">
          </customer-title-content>
          <customer-simple-input
            [placeholder]="labels.systemNamePlaceholder"
            [input]="importSystemName">
          </customer-simple-input>
          <!-- Import -->
          <ng-container *ngIf="azzurroHubSerial?.errors?.serial as serial">
            <customer-simple-button
              [label]="labels.import"
              [disabled]="!importSystemName.value"
              [action]="importSystemName.value && createPlant(importSystemName.value, serial)">
            </customer-simple-button>
          </ng-container>
        </ng-container>
      </section>
    </ng-container>
  </ng-template>

  <!-- Azzurro Hub busy -->
  <ng-template #checkAzzurroHubBusy>
    <section
      *ngIf="azzurroHubSerial?.errors?.azzurroHubBusy; else checkAzzurroHubIfOnline"
      class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
      <customer-icon-text [text]="labels.requiredOperation">
      </customer-icon-text>
      <customer-title-content [content]="labels.azzurroHubBusyDescription">
      </customer-title-content>
      <customer-simple-button
        [label]="labels.checkAgain"
        [action]="updateValueAndValidity">
      </customer-simple-button>
    </section>
  </ng-template>

  <!-- Device Not Online -->
  <ng-template #checkAzzurroHubIfOnline>
    <section
      *ngIf="azzurroHubSerial?.errors?.deviceNotOnline; else checkAzzurroHubIfFwVersionNotValid"
      class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
      <customer-icon-text [text]="labels.offlineDevice">
      </customer-icon-text>
      <customer-title-content [content]="labels.offlineDeviceDescription">
      </customer-title-content>
      <customer-simple-button
        [label]="labels.checkAgain"
        [action]="updateValueAndValidity">
      </customer-simple-button>
    </section>
  </ng-template>

  <!-- Device with fw version not valid -->
  <ng-template #checkAzzurroHubIfFwVersionNotValid>
    <section
      *ngIf="azzurroHubSerial?.errors?.fwVersionNotValid"
      class="p-3 border-1 bg-orange-100 border-orange-400 fx-col fx-gap-3 mt-3 radius-4">
      <customer-icon-text [text]="labels.requiredOperation">
      </customer-icon-text>
      <customer-title-content [content]="labels.firmwareNotValidDescription">
      </customer-title-content>

      <!-- TODO: Implement Azzurro Hub firmware upgrade if needed -->
      <customer-simple-button
        [label]="labels.checkAgain"
        [action]="updateValueAndValidity">
      </customer-simple-button>
    </section>
  </ng-template>
</section>
